const rankings = [
  { rank: 1, title: '绝世神医：开局签到至尊骨', genre: '奇幻冒险', heat: '🔥 98.6', tag: '本周新晋' },
  { rank: 2, title: '重生之都市修仙', genre: '都市玄幻', heat: '🔥 97.2', tag: '持续霸榜' },
  { rank: 3, title: '总裁的替身前妻', genre: '浪漫恋爱', heat: '🔥 95.8', tag: '口碑炸裂' },
  { rank: 4, title: '暗影刺客成长记', genre: '热血动作', heat: '🔥 94.3', tag: '人气飙升' },
  { rank: 5, title: '异世界开局满级', genre: '异世界', heat: '🔥 92.7', tag: '话题热议' },
  { rank: 6, title: '九尾狐的恋爱法则', genre: '浪漫恋爱', heat: '🔥 91.4', tag: '新作上榜' },
  { rank: 7, title: '末日生存手册', genre: '悬疑惊悚', heat: '🔥 90.1', tag: '强力推荐' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">人气排行</h2>
          <p className="mt-3 text-sm text-foreground-600">韩国漫画人气榜 · 高分必看实时更新</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 py-3.5 border-b border-background-200/70 last:border-b-0 group cursor-pointer hover:bg-background-50 px-3 -mx-3 rounded-md transition-colors"
            >
              <div className={`w-8 h-8 rounded-md flex items-center justify-center flex-shrink-0 font-heading text-sm ${
                item.rank <= 3
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 whitespace-nowrap truncate group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500">{item.genre}</span>
              </div>
              <div className="text-sm font-heading text-foreground-800 whitespace-nowrap">{item.heat}</div>
              <span className="hidden sm:inline-flex text-xs px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}